export const switchingContextSelector = (state) => Boolean(state.appReducer.switchingContext);

export const contextSwitchMessageSelector = (state) => state.appReducer.contextSwitchMessage || 'Loading…';
